import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "./app-config.service";
@Injectable({
    providedIn: 'root'
})

export class mwoService {
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    apiUrl = AppConfig.settings.apiUrl;
    constructor(private http: HttpClient) {

    }

    public getMwoSearch(reqbody: any) {
        return this.http.post<any>(`${this.apiUrl}Mwo/GetMwoSearch`, reqbody, this.httpOptions);
    }

    public updateMwo(reqData: any) {
        return this.http.post<any>(
            `${this.apiUrl}Mwo/UpdateMwoBuild`, reqData, this.httpOptions);
    }

    public getMwodata(crno: any) {
        return this.http.get<any>(`${this.apiUrl}Mwo/GetMwoBuild?CRID=${crno}`, this.httpOptions);
    }
    public getMwoDropdownData(flag: any) {
        return this.http.get<any>(`${this.apiUrl}MwoDropdown/GetMwoDropdown?tableName=${flag}`, this.httpOptions);

    }
     public getMwoDropdownAllData() {
        return this.http.get<any>(`${this.apiUrl}MwoDropdown/GetAllMmoDropdownsAsync`, this.httpOptions);

    }
    //MwoDropdown/GetMwoDropdown?tableName=Wr01_Woclassification1
    public createNewMwo(reqData: any) {
        return this.http.post<any>(
            `${this.apiUrl}Mwo/CreateMwoBuild`, reqData, this.httpOptions);
    }

    public copyAboveMwo(reqData: any) {
        return this.http.post<any>(`${this.apiUrl}Mwo/CopyMwoBuild`, reqData, this.httpOptions);
    }

    public deleteMwo(reqData: any) {
        return this.http.post<any>(
            `${this.apiUrl}Mwo/DeleteMwoBuild`, reqData, this.httpOptions
        );
    }

    public saveAndAddToCr(reqbody: any, crno: any) {
        return this.http.put<any>(
            `${this.apiUrl}Mwo/SaveMWOBuild?CRID=${crno}`, reqbody, this.httpOptions
        );
    }

    public ValidateMWO(reqbody: any, crno: any) {
        return this.http.post<any>(
            `${this.apiUrl}Mwo/ValidationMWOBuild?CRID=${crno}`, reqbody, this.httpOptions
        );
    }

    public ValidateImportMWOBuild(reqbody: any, crno: any) {
        return this.http.post<any>(
            `${this.apiUrl}Mwo/ImportMWOBuild?CRID=${crno}`, reqbody, this.httpOptions
        );
    }

    public AcdSummary(crid: any) {
        return this.http.get<any>(`${this.apiUrl}Mwo/GetACDSummary?CRID=${crid}`, this.httpOptions);
    }

    getAssignExecTag(skip: number, pageSize: number = 5, searchText: string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}Mwo/GetAssignedExecutionCodeDetails${url}`, this.httpOptions);
    }

    getAreaOwnerCode(skip: number, pageSize: number = 5, searchText: string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}Mwo/GetAreaCodeDetails${url}`, this.httpOptions);
    }

    getLeadCraftCode(skip: number, pageSize: number = 5, searchText: string, crId: number) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}&CrId=${crId}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}Mwo/GetLeadCraftDetails${url}`, this.httpOptions);
    }

    getJobPlanData(skip: number, pageSize: number = 5, searchText: string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}Mwo/GetJobPlanDetails${url}`, this.httpOptions);
    }

    public getPerfomanceStandard(equipTagNumbers: string[] = []) {
        let url = "";
        if (equipTagNumbers.length > 0) {
            url = `?equipTagNumber=${equipTagNumbers.join(";")}`;
        }
        return this.http.get<any>(`${this.apiUrl}MwoDropdown/GetPerfomanceStandard${url}`, this.httpOptions);

    }

    public getPerfomanceStandardNew(equipTagNumbers: string[] = []) {
       /*  let payload  = {
            "equipTagNumber": equipTagNumbers.join(";")
        } */
        let payload = JSON.stringify(equipTagNumbers.join(";")); // Send as a JSON string
        return this.http.post<any>(`${this.apiUrl}MwoDropdown/GetPerfomanceStandardNew`,equipTagNumbers, this.httpOptions);

    }

    getEquipTag(skip: number, pageSize: number = 5, searchText: string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}Mwo/GetEquipTag${url}`, this.httpOptions);
    }

}